// The function place and the radius vendors are shown within — used by the Service Wizard
// and Service Providers. Distances come from the server's known-city list.
import React from 'react';
import { useQuery } from '@apollo/client';
import { Autocomplete, TextField, Stack, Chip, InputAdornment } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
import { KNOWN_CITIES_QUERY } from '../graphql/queries';

export const RADIUS_OPTIONS = [25, 50, 100, 200];
export const DEFAULT_RADIUS = 50;

export function EventCityField({ value, onChange, label = 'Where will the function take place?', size, required, helperText }) {
  const { data } = useQuery(KNOWN_CITIES_QUERY, { fetchPolicy: 'cache-first' });
  const cities = data?.knownCities || [];
  const known = !value || cities.some(c => c.toLowerCase() === value.trim().toLowerCase());
  return (
    <Autocomplete
      freeSolo
      options={cities}
      value={value || ''}
      onInputChange={(_, v) => onChange(v)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          size={size}
          required={required}
          placeholder="City, e.g. Chennai"
          helperText={!known ? "We don't have this city's location yet — vendors will be shown without distances" : helperText}
          InputProps={{
            ...params.InputProps,
            startAdornment: <InputAdornment position="start"><PlaceIcon fontSize="small" color="action" /></InputAdornment>,
          }}
        />
      )}
    />
  );
}

// allowAny adds an "Any distance" choice (value null)
export function RadiusChips({ value, onChange, allowAny = false }) {
  return (
    <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap alignItems="center">
      {RADIUS_OPTIONS.map(km => (
        <Chip
          key={km}
          size="small"
          label={`${km} km`}
          color={value === km ? 'primary' : 'default'}
          variant={value === km ? 'filled' : 'outlined'}
          onClick={() => onChange(km)}
        />
      ))}
      {allowAny && (
        <Chip
          size="small"
          label="Any distance"
          color={value == null ? 'primary' : 'default'}
          variant={value == null ? 'filled' : 'outlined'}
          onClick={() => onChange(null)}
        />
      )}
    </Stack>
  );
}

export const distanceLabel = (v, place) => (
  v.distanceKm == null ? null
    : v.distanceKm === 0 ? `In ${place}`
    : `${v.distanceKm.toLocaleString('en-IN')} km away`
);
